import { render, staticRenderFns } from "./FinalExamTeacherStudListView.vue?vue&type=template&id=64fcadae"
import script from "./FinalExamTeacherStudListView.vue?vue&type=script&lang=js"
export * from "./FinalExamTeacherStudListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports